<t4-header></t4-header>
<t4-periodPicker [(from)]="fromDate" [(to)]="toDate" (periodChanged)="loadData()"></t4-periodPicker>
<t4-container>
  <t4-data-table #tbl headline="" matSort reportName="OnewayHistoricalReturnReport" [parameters]="{from: fromDate, to:toDate}" [autoGenerateColumns]="false" [filterFields]="['RentalId', 'PickupLocationId', 'ReturnLocationId', 'PickupLocation', 'ReturnLocation', 'Customer', 'StartTime', 'EndTime']">
    <ng-container matColumnDef="RentalId">
      <mat-header-cell *matHeaderCellDef mat-sort-header>RentalId</mat-header-cell>
      <mat-cell *matCellDef="let row"><t4-booking-link bookingId="{{row.RentalId}}"></t4-booking-link></mat-cell>
      <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
    </ng-container>
    <ng-container matColumnDef="PickupLocation">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Pickup Location</mat-header-cell>
      <mat-cell *matCellDef="let row"><t4-location-link [locationId]="row.PickupLocationId">{{ row.PickupLocation }}</t4-location-link></mat-cell>
      <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
    </ng-container>
    <ng-container matColumnDef="ReturnLocation">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Return Location</mat-header-cell>
      <mat-cell *matCellDef="let row"><t4-location-link [locationId]="row.ReturnLocationId">{{ row.ReturnLocation }}</t4-location-link></mat-cell>
      <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
    </ng-container>
    <ng-container matColumnDef="Customer">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Customer</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.Customer }}</mat-cell>
      <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
    </ng-container>
    <ng-container matColumnDef="StartTime">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Start Time</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.StartTime | date : 'yyyy-MM-dd hh:mm:ss' }}</mat-cell>
      <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
    </ng-container>
    <ng-container matColumnDef="EndTime">
      <mat-header-cell *matHeaderCellDef mat-sort-header>End time</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.EndTime | date : 'yyyy-MM-dd hh:mm:ss' }}</mat-cell>
      <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
    </ng-container>
  </t4-data-table>
</t4-container>
